import * as service from './service'
export default {
  namespace: 'customerServiceAppealRecords',
  state: {
    demoData: {}
  },
  effects: {
    * queryCsAppealList ({ payload }, { call, put }) {
      const res = yield call(service.queryCsAppealList, payload)
      return res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
